import React from "react";
import { MED_STATUS_LABEL, MED_STATUS_TONE, medStatusOfView, type MedStatus } from "../server/station/med-status";

/**
 * THE medication status badge (M3 Stage 3 fix 1): one badge per medication,
 * from the one status function the server's reports use too. Never shown
 * beside another status badge for the same medication.
 */
export function MedStatusBadge({ m, status }: { m?: Parameters<typeof medStatusOfView>[0]; status?: MedStatus }): React.ReactElement {
  const s = status ?? medStatusOfView(m);
  return <span className={`rounded px-1.5 py-0.5 text-xs font-medium ${MED_STATUS_TONE[s]}`}>{MED_STATUS_LABEL[s]}</span>;
}

/** A medication no longer given (Discontinued, or the student departed): the record shows no schedule for it (the data stays). */
export const notGiven = (m: { status?: string } | null | undefined): boolean => m?.status === "Discontinued" || m?.status === "Departed";

/** A medication's return (M5), one line: what, when, by whom, and the signed receipt or sheet. */
export interface ReturnSummaryView {
  status: string;
  text: string;
  docKey: string;
  docLabel: string;
}
export function MedReturnLine({ r }: { r: ReturnSummaryView | null | undefined }): React.ReactElement | null {
  if (!r) return null;
  return (
    <p className="mt-1 text-sm text-slate-700">
      <span className="font-medium">Medication return:</span> {r.text}
      {r.docKey && <>; <a className="text-program underline" href={`/api/med-documents/${encodeURIComponent(r.docKey)}`} target="_blank" rel="noreferrer">{r.docLabel}</a></>}
    </p>
  );
}
